import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Link } from '@uhg-abyss/web/ui/Link';
import { event } from '@uhg-abyss/web/tools/event';
import { Breadcrumb } from './Breadcrumb';
import { DefaultDivider } from './DefaultDivider';

const StyledDiv = styled('div', {
  root: {},
  divider: {
    margin: '0 5px',
    '& > svg': {
      color: '#CCCCCC',
      width: '0.625rem',
      height: '0.625rem',
    },
  },
});

export const initShowDivider = (items) => (i) => i > 0 && i < items.length;

export const Breadcrumbs = ({
  Divider,
  items,
  customBreadCrumb,
  onclickHandler,
}) => {
  const showDivider = initShowDivider(items);
  const breadcrumbItems = items.map((obj) => ({
    ...obj,
    onClick: () => {
      event('PAGE_NAV_CLICK', { linkName: obj.label });
    },
  }));
  const checkIfHomeURL = (url) => {
    const homeURL = '/';
    return url === homeURL;
  };
  return (
    <StyledDiv>
      {breadcrumbItems.map(({ url, label, onClick, id = '' }, i) => (
        <React.Fragment key={`breadcrumb-${label}-${id}`}>
          <If condition={showDivider(i)}>
            <DefaultDivider />
          </If>
          <Breadcrumb
            id={id}
            route={url}
            label={label}
            isLast={i === items.length - 1}
            customLink={
              customBreadCrumb ? (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <Link onClick={() => onclickHandler(url, label)}>{label}</Link>
              ) : null
            }
            onClick={onClick}
          />
        </React.Fragment>
      ))}
    </StyledDiv>
  );
};

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      route: PropTypes.string,
    })
  ).isRequired,
  Divider: PropTypes.node,
  className: PropTypes.string,
  customBreadCrumb: PropTypes.bool,
  onclickHandler: PropTypes.func,
};

Breadcrumbs.defaultProps = {
  className: null,
  Divider: <DefaultDivider />,
  customBreadCrumb: false,
  onclickHandler: () => {},
};
